import React from 'react'
import styles from "../vendorprofile/myprofile.module.css"
import VendorProfileMenu from '../../Components/vendorprofilemenu/VendorProfileMenu';
import AddNewVendorComp from '../../Components/addNewVendorComp/AddNewVendorComp';

const AddNewVendor = () => {
    return (
        <>
            <div className={styles.myprofile}>
                <div className={styles.promenu}>
                    <VendorProfileMenu />
                </div>
                    <AddNewVendorComp />
            </div>


        </>
    )
}

export default AddNewVendor